import { swalError, swalSuccess } from "../../../helpers/swal";
import * as requestFromServer from "./applicantRequest";
import { callTypes, applicantSlice } from "./applicantSlice";

const { actions } = applicantSlice;

export const getAllSortedApplicants = (payload, currentPage, pageSize) => (
  dispatch,
  getState
) => {
  // const { entities } = getState().applicant;
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getSortedApplicantList(payload, currentPage, pageSize)
    .then((response) => {
      if (response.data.success) {
        const { data } = response.data;

        // const updatedApplicants =
        //   currentPage === 1
        //     ? data.hrms_job_application
        //     : [...entities, ...data.hrms_job_application];

        dispatch(
          actions.allSortedApplicantFetched({
            totalCount: data?.allApplicantCount,
            entities: data?.hrms_job_application,
            hasMore: data?.hrms_job_application?.length > 0,
            shortlistedApplicantList: data,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const setUpdatedJobApplications = (jobApplications, totalCount) => (
  dispatch
) => {
  dispatch(
    actions.allSortedApplicantFetched({
      entities: jobApplications,
      totalCount,
      hasMore: !!jobApplications?.length,
    })
  );
};

export const getAllSortedApplicantsForPaginate = (
  prevData,
  payload,
  currentPage,
  pageSize
) => (dispatch) => {
  // console.log(prevData, "paginate");
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getSortedApplicantListForPaginate(payload, currentPage, pageSize)
    .then((response) => {
      if (response.data.success) {
        const { data } = response.data;
        dispatch(
          actions.allSortedApplicantFetched({
            totalCount: data.totalItems,
            entities: data.hrms_job_application,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getAllPublications = () => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getPublicationOrganizations()
    .then((response) => {
      if (response.data.success) {
        const { data } = response.data;
        dispatch(
          actions.allPublicationsOrganizations({
            entities: data,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getEducationLevels = () => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getEducationLevels()
    .then((response) => {
      if (response.data.success) {
        const { data } = response.data;
        dispatch(
          actions.allEducationLevels({
            entities: data,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};
export const getMajorSubjects = () => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getMejorSubjects()
    .then((response) => {
      if (response.data.success) {
        const { data } = response.data;
        dispatch(
          actions.allMejorSubjects({
            entities: data,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getAllInterviews = (payload) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getInterviewScheduleList(payload)
    .then((response) => {
      if (response.data.success) {
        const { data } = response.data;
        dispatch(
          actions.allInterviewFetched({
            totalCount: data.totalItems,
            interviews: data.hrms_job,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getAllApprovedInterviews = (payload) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getApprovedInterviewScheduleList(payload)
    .then((response) => {
      if (response.data.success) {
        const { data } = response.data;
        dispatch(
          actions.allApprovedInterviewFetched({
            totalCount: data.totalItems,
            interviews: data.hrms_interview_schedule,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getOneApplicantDetails = (payload) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getOneApplicantDetails(payload)
    .then((response) => {
      if (response.data.success) {
        const { data } = response.data;
        dispatch(
          actions.applicantDetails({
            cv_view: data,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getAllEmployeeList = () => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getEmployeeList()
    .then((response) => {
      if (response.data.success) {
        const { data } = response.data;
        dispatch(
          actions.employeeListFetched({
            employeeList: data.sys_users,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getAllJobList = (payload) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getJobList(payload)
    .then((response) => {
      if (response.data.success) {
        const { data } = response.data;
        dispatch(
          actions.jobListFetched({
            jobList: data.hrms_job,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getAllInterviewJobList = (payload) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getInterviewJobList(payload)
    .then((response) => {
      if (response.data.success) {
        const { data } = response.data;
        dispatch(
          actions.jobInterviewListFetched({
            interviewJob: data.hrms_job,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getInterviewJobListByType = (job_id, interview_type_id) => (
  dispatch
) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getInterviewJobListByType(job_id, interview_type_id)
    .then((response) => {
      if (response.data.success) {
        const { data } = response.data;
        console.log({ data });
        dispatch(
          actions.scheduleInfoFetched({
            scheduleForEdit: data,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getInterviewScheduleInfo = (id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getInterviewScheduleInfo(id)
    .then((response) => {
      if (response.data.success) {
        const { data } = response.data;
        dispatch(
          actions.scheduleInfoFetched({
            scheduleForEdit: data,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const removeApplicants = (id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return dispatch(
    actions.applicantDeleted({
      id: id,
    })
  );
};

export const getQuestionsByJobDescription = (applicantId, id, type_id) => (
  dispatch
) => {
  if (!applicantId && !id && !type_id) {
    return dispatch(
      actions.jobDescriptionQuestions({
        questions: null,
      })
    );
  }
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getQuestionsByJobDescription(applicantId, id, type_id)
    .then((response) => {
      if (response.data.success) {
        const { data } = response.data;
        const ques = data?.hrms_applicant_assessment;
        dispatch(
          actions.jobDescriptionQuestions({
            questions: ques,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getAccessorData = (payload) => (dispatch) => {
  if (!payload) {
    return dispatch(
      actions.accessorData({
        accessorData: null,
      })
    );
  }
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getAccessorData(payload)
    .then((response) => {
      if (response.data.success) {
        const { data } = response.data;
        const ques = data;
        dispatch(
          actions.accessorData({
            accessorData: ques,
          })
        );
        if (data?.message) {
          swalError(data?.message);
        }
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getIntervieweTypeByReq = (payload) => (dispatch) => {
  if (!payload) {
    return dispatch(
      actions.interviewTypeList({
        interviewTypeList: null,
      })
    );
  }
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getIntervieweTypeByReq(payload)
    .then((response) => {
      if (response.data.success) {
        console.log(response);
        const { data } = response.data;
        const ques = data?.hrms_question_type?.map((item) => {
          return {
            value: item?.hrms_question_type__id,
            label: item?.hrms_question_type__name,
          };
        });
        dispatch(
          actions.interviewTypeList({
            interviewTypeList: ques,
          })
        );
        if (data?.message) {
          swalError(data?.message);
        }
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getInterviewers = (applicantId, jobId, type_id, role = null) => (
  dispatch
) => {
  if (!applicantId && !jobId && !type_id) {
    return dispatch(
      actions.getInterviewers({
        interviewer: null,
      })
    );
  }
  dispatch(actions.startCall({ callType: callTypes.action }));
  // role == "hr_admin"
  const api =
    role && role == "hr_admin"
      ? requestFromServer.getEmployeeUsers()
      : requestFromServer.getInterviewers(applicantId, jobId, type_id);
  return api
    .then((response) => {
      if (response.data.success) {
        const { data } = response.data;
        let ques = [];
        if (role && role == "hr_admin") {
          ques = data;
        } else {
          ques = data?.map((item) => {
            return {
              label: item?.full_name,
              value: item?.user_id,
            };
          });
        }

        dispatch(
          actions.getInterviewers({
            interviewer: ques,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getQuestionsByJob = (id) => (dispatch) => {
  if (!id) {
    return dispatch(
      actions.jobQuestions({
        questions_match: null,
      })
    );
  }
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getQuestionsByJob(id)
    .then((response) => {
      if (response.data.success) {
        const { data } = response.data;
        const ques = data[0];
        dispatch(
          actions.jobQuestions({
            questions_match: ques,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const createEducation = (payload) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .createEducation(payload)
    .then((response) => {
      if (response.data.success) {
        swalSuccess("Education Added");
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const createEducationForApplicant = (payload) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .createEducationForApplicant(payload)
    .then((response) => {
      if (response.data.success) {
        swalSuccess("Education Added");
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getAssessmentList = (payload) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getAssessmentList(payload)
    .then((response) => {
      if (response.data.success) {
        dispatch(
          actions.assessmentListFetched({
            assessmentList: response.data?.data?.hrms_applicant,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const createCertificate = (payload) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .createCertificate(payload)
    .then((response) => {
      if (response.data.success) {
        swalSuccess("Certification Added");
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const createCertificateForApplicant = (payload) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .createCertificateForApplicant(payload)
    .then((response) => {
      if (response.data.success) {
        swalSuccess("Certification Added");
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const createExperience = (payload) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .createExperience(payload)
    .then((response) => {
      if (response.data.success) {
        swalSuccess("Experienced Added");
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const createExperienceForApplicant = (payload) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .createExperienceForApplicant(payload)
    .then((response) => {
      if (response.data.success) {
        swalSuccess("Experienced Added");
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const createTraining = (payload) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .createTraining(payload)
    .then((response) => {
      if (response.data.success) {
        swalSuccess("Training Added");
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const createTrainingForApplicant = (payload) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .createTrainingForapplicant(payload)
    .then((response) => {
      if (response.data.success) {
        swalSuccess("Training Added");
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const updateEducation = (payload, id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateEducation(payload, id)
    .then((response) => {
      if (response.data.success) {
        swalSuccess("Education Updated");
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const updateEducationForApplicant = (payload, id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateEducationForApplicant(payload, id)
    .then((response) => {
      if (response.data.success) {
        swalSuccess("Education Updated");
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const updateTraining = (payload, id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateTraining(payload, id)
    .then((response) => {
      if (response.data.success) {
        swalSuccess("Training Updated");
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const updateTrainingForApplicant = (payload, id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateTrainingForApplicant(payload, id)
    .then((response) => {
      if (response.data.success) {
        swalSuccess("Training Updated");
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const updateCerificate = (payload, id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateCertificate(payload, id)
    .then((response) => {
      if (response.data.success) {
        swalSuccess("Certificate Updated");
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const updateCerificateForApplicant = (payload, id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateCertificateForApplicant(payload, id)
    .then((response) => {
      if (response.data.success) {
        swalSuccess("Certificate Updated");
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const updateExperienced = (payload, id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateExperienced(payload, id)
    .then((response) => {
      if (response.data.success) {
        swalSuccess("Experienced Updated");
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const updateExperiencedForApplicant = (payload, id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateExperiencedForApplicant(payload, id)
    .then((response) => {
      if (response.data.success) {
        swalSuccess("Experienced Updated");
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const deleteEducation = (id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .deleteEducation(id)
    .then((response) => {
      if (response.data.success) {
        swalSuccess("Education Deleted");
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const deleteEducationForApplicant = (id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .deleteEducationForApplicant(id)
    .then((response) => {
      if (response.data.success) {
        swalSuccess("Education Deleted");
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const deleteCertificate = (id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .deleteCertificate(id)
    .then((response) => {
      if (response.data.success) {
        swalSuccess("Certificate Deleted");
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const deleteCertificateForApplicant = (id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .deleteCertificateForApplicant(id)
    .then((response) => {
      if (response.data.success) {
        swalSuccess("Certificate Deleted");
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const deleteExperienced = (id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .deleteExperienced(id)
    .then((response) => {
      if (response.data.success) {
        swalSuccess("Experienced Deleted");
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const deleteExperiencedForApplicant = (id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .deleteExperiencedForApplicant(id)
    .then((response) => {
      if (response.data.success) {
        swalSuccess("Experienced Deleted");
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const deleteTraining = (id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .deleteTraining(id)
    .then((response) => {
      if (response.data.success) {
        swalSuccess("Training Deleted");
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const deleteTrainingForApplicant = (id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .deleteTrainingForApplicant(id)
    .then((response) => {
      if (response.data.success) {
        swalSuccess("Training Deleted");
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getAllEducationLavel = () => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getAllEducationLavel()
    .then((response) => {
      if (response.data.success) {
        const educationLavel = response.data?.data?.hrms_education_level?.map(
          (item) => {
            return {
              value: item?.hrms_education_level__id,
              label: item?.hrms_education_level__name,
              slug: item?.hrms_education_level__slug,
            };
          }
        );
        dispatch(
          actions.educationLavelFetched({
            educationLavel,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getAllNationalityList = () => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getAllNationality()
    .then((response) => {
      if (response.data.success) {
        const nationalityList = response.data?.data?.hrms_nationality?.map(
          (item) => {
            return {
              value: item?.hrms_nationality__id,
              label: item?.hrms_nationality__name,
            };
          }
        );
        dispatch(
          actions.nationalityListFetched({
            nationalityList,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getAllCountry = () => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getCountryList()
    .then((response) => {
      if (response.data.success) {
        const countryList = response.data?.data?.config_countries?.map(
          (item) => {
            return {
              value: item?.config_countries__country_id,
              label: item?.config_countries__country_name,
            };
          }
        );
        dispatch(
          actions.countryListFetched({
            countryList,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getAllEducationByApplicants = (id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getEducationByApplicantId(id)
    .then((response) => {
      if (response.data.success) {
        dispatch(
          actions.educationListFetched({
            educationList: response.data.data.hrms_education,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getAllEducation = () => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getEducation()
    .then((response) => {
      if (response.data.success) {
        const list = response.data.data.hrms_education_level?.map((item) => {
          return {
            value: item?.hrms_education_level__name,
            label: item?.hrms_education_level__name,
          };
        });
        dispatch(
          actions.educationListAllFetched({
            educationList: list,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getAllEducationForApplicants = (id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getEducationForApplicantId(id)
    .then((response) => {
      if (response.data.success) {
        dispatch(
          actions.educationListFetched({
            educationList: response.data.data.hrms_education,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getAllTrainingByApplicants = (id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getTrainingList(id)
    .then((response) => {
      if (response.data.success) {
        dispatch(
          actions.trainingFetched({
            trainingList: response.data.data.hrms_training,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getAllTrainingForApplicants = (id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getTrainingListForApplicant(id)
    .then((response) => {
      if (response.data.success) {
        dispatch(
          actions.trainingFetched({
            trainingList: response.data.data.hrms_training,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getAllCertificateByApplicants = (id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getCertificateByApplicantId(id)
    .then((response) => {
      if (response.data.success) {
        dispatch(
          actions.certificationListFetched({
            certificationList:
              response.data.data.hrms_professional_certification,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getAllCertificateForApplicants = (id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getCertificateForApplicantId(id)
    .then((response) => {
      if (response.data.success) {
        dispatch(
          actions.certificationListFetched({
            certificationList:
              response.data.data.hrms_professional_certification,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getAllDocumentByApplicants = (id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getDocumentByApplicantId(id)
    .then((response) => {
      if (response.data.success) {
        dispatch(
          actions.documentListFetched({
            documentList: response.data.data.hrms_user_required_documents,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getAllDocumentForApplicants = (id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getDocumentForApplicantId(id)
    .then((response) => {
      if (response.data.success) {
        dispatch(
          actions.documentListFetched({
            documentList: response.data.data.hrms_user_required_documents,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getAllExperiencedByApplicants = (id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getExperiencedByApplicantId(id)
    .then((response) => {
      if (response.data.success) {
        dispatch(
          actions.experienceFetched({
            experienceList: response.data.data.hrms_experience,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getAllExperiencedForApplicants = (id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getExperiencedForApplicantId(id)
    .then((response) => {
      if (response.data.success) {
        dispatch(
          actions.experienceFetched({
            experienceList: response.data.data.hrms_experience,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getAllDegree = () => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getAllDegree()
    .then((response) => {
      if (response.data.success) {
        const degree = response.data?.data?.hrms_degree?.map((item) => {
          return {
            value: item?.hrms_degree__id,
            label: item?.hrms_degree__name,
          };
        });

        dispatch(
          actions.degreeFetched({
            degree,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getAllResultType = () => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getAllResultType()
    .then((response) => {
      if (response.data.success) {
        const resultType = response.data?.data?.hrms_result_type?.map(
          (item) => {
            return {
              value: item?.hrms_result_type__id,
              label: item?.hrms_result_type__name,
            };
          }
        );
        dispatch(
          actions.resultTypeFetched({
            resultType,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getAllDocumentType = () => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getDocumentType()
    .then((response) => {
      if (response.data.success) {
        const documentType = response.data?.data?.hrms_documents_config?.map(
          (item) => {
            return {
              value: item?.hrms_documents_config__id,
              label: item?.hrms_documents__name,
            };
          }
        );
        dispatch(
          actions.documentTypeFetched({
            documentType,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getAllBoard = () => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getAllBoard()
    .then((response) => {
      if (response.data.success) {
        const board = response.data?.data?.hrms_board?.map((item) => {
          return {
            value: item?.hrms_board__id,
            label: item?.hrms_board__name,
          };
        });
        dispatch(
          actions.boardFetched({
            board,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getAllInstitute = () => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getAllInstitute()
    .then((response) => {
      if (response.data.success) {
        const institute = response.data?.data?.hrms_institute?.map((item) => {
          return {
            value: item?.hrms_institute__id,
            label: item?.hrms_institute__name,
          };
        });
        dispatch(
          actions.instituteFetched({
            institute,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getAllMajorSubject = () => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getAllMajorSubject()
    .then((response) => {
      if (response.data.success) {
        const majorSubject = response.data?.data?.hrms_major_subject?.map(
          (item) => {
            return {
              value: item?.hrms_major_subject__id,
              label: item?.hrms_major_subject__name,
            };
          }
        );
        dispatch(
          actions.majorSubjectFetched({
            majorSubject,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getAllDivision = () => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getAllDivision()
    .then((response) => {
      if (response.data.success) {
        const division = response.data?.data?.sys_geo_divisions?.map((item) => {
          return {
            value: item?.sys_geo_divisions__geo_division_id,
            label: item?.sys_geo_divisions__geo_division_name,
          };
        });
        dispatch(
          actions.divisionListFetched({
            division,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getAllPreDistrictByDivision = (division) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getAllDistrict(division)
    .then((response) => {
      if (response.data.success) {
        const pre_district = response.data?.data?.rows?.map((item) => {
          return {
            value: item?.geo_district_id,
            label: item?.geo_district_name,
          };
        });
        dispatch(
          actions.preDistrictListFetched({
            pre_district,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getAllPerDistrictByDivision = (division) => (dispatch) => {
  if (!division) {
    return dispatch(
      actions.perDistrictListFetched({
        per_district: null,
      })
    );
  }
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getAllDistrict(division)
    .then((response) => {
      if (response.data.success) {
        const per_district = response.data?.data?.rows?.map((item) => {
          return {
            value: item?.geo_district_id,
            label: item?.geo_district_name,
          };
        });
        dispatch(
          actions.perDistrictListFetched({
            per_district,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getAllBankList = () => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getBankList()
    .then((response) => {
      if (response.data.success) {
        const bankList = response.data?.data?.hrms_bank?.map((item) => {
          return {
            value: item?.hrms_bank__id,
            label: item?.hrms_bank__full_name,
          };
        });
        dispatch(
          actions.bankListFetched({
            bankList,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getAllBranchByBank = (id) => (dispatch) => {
  if (!id) {
    return dispatch(
      actions.branchListFetched({
        branchList: null,
      })
    );
  }
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getAllBranchByBank(id)
    .then((response) => {
      if (response.data.success) {
        const branchList = response.data?.data?.hrms_branch?.map((item) => {
          return {
            value: item?.hrms_branch__id,
            label: item?.hrms_branch__name,
          };
        });
        dispatch(
          actions.branchListFetched({
            branchList,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getAllPerThanaDistrictByDivision = (division, district) => (
  dispatch
) => {
  if (!division && !district) {
    return dispatch(
      actions.perThanaListFetched({
        per_thana: null,
      })
    );
  }

  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getAllThana(division, district)
    .then((response) => {
      if (response.data.success) {
        const per_thana = response.data?.data?.rows?.map((item) => {
          return {
            value: item?.id,
            label: item?.name,
          };
        });
        dispatch(
          actions.perThanaListFetched({
            per_thana,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getAllPreThanaDistrictByDivision = (division, district) => (
  dispatch
) => {
  if (!division && !district) {
    return dispatch(
      actions.preThanaListFetched({
        pre_thana: null,
      })
    );
  }

  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getAllThana(division, district)
    .then((response) => {
      if (response.data.success) {
        const pre_thana = response.data?.data?.rows?.map((item) => {
          return {
            value: item?.id,
            label: item?.name,
          };
        });
        dispatch(
          actions.preThanaListFetched({
            pre_thana,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getPersonalInfo = (id) => (dispatch) => {
  if (!id) {
    return dispatch(
      actions.personalInfoFetched({
        personal_info: null,
      })
    );
  }

  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getEmployeePersonalInfo(id)
    .then((response) => {
      if (response.data.success) {
        const personal_info = response.data?.data;
        dispatch(
          actions.personalInfoFetched({
            personal_info,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getPublicationCommonData = (applicantId) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getPublicationCommonData(applicantId)
    .then((response) => {
      if (response?.data?.data) {
        dispatch(
          actions.publicationCommonDataFethced({
            publicationCommonData: response?.data?.data,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
          swalError("someting went wrong");
        }
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getPublicationData = (applicantId) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getPublicationData(applicantId)
    .then((response) => {
      if (response?.data?.data) {
        dispatch(
          actions.publicationCommonDataFethced({
            publicationCommonData: response?.data?.data,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
          swalError("someting went wrong");
        }
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getApplicantPersonalInfo = (id) => (dispatch) => {
  if (!id) {
    return dispatch(
      actions.personalInfoFetched({
        personal_info: null,
      })
    );
  }

  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getApplicantPersonalInfo(id)
    .then((response) => {
      if (response.data.success) {
        const personal_info = response.data?.data;
        dispatch(
          actions.personalInfoFetched({
            personal_info,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getAllCertificate = () => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getCertificationList()
    .then((response) => {
      if (response.data.success) {
        const certificate = response.data?.data?.hrms_certification?.map(
          (item) => {
            return {
              value: item?.hrms_certification__id,
              label: item?.hrms_certification__name,
            };
          }
        );
        dispatch(
          actions.certificationFetched({
            certificate,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getAllUserBanks = (id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getUserBankList(id)
    .then((response) => {
      if (response.data.success) {
        const banks = response.data?.data?.hrms_user_bank_info;
        dispatch(
          actions.banksFetched({
            banks,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getAllUserBanksForApplicant = (id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getUserBankListForApplicant(id)
    .then((response) => {
      if (response.data.success) {
        const banks = response.data?.data?.hrms_user_bank_info;
        dispatch(
          actions.banksFetched({
            banks,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getAllIndustryType = () => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getIndustryType()
    .then((response) => {
      if (response.data.success) {
        const industryType = response.data?.data?.hrms_industry_type?.map(
          (item) => {
            return {
              value: item?.hrms_industry_type__id,
              label: item?.hrms_industry_type__name,
            };
          }
        );
        dispatch(
          actions.industryTypeFetched({
            industryType,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getAdditionalInfo = (id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getAdditionalInfo(id)
    .then((response) => {
      if (response.data.success) {
        const additionInfo =
          response.data?.data?.hrms_additional_information[0];
        dispatch(
          actions.additionalFetched({
            additionInfo,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getAdditionalInfoForApplicant = (id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getAdditionalInfoForApplicant(id)
    .then((response) => {
      if (response.data.success) {
        const additionInfo =
          response.data?.data?.hrms_additional_information[0];
        dispatch(
          actions.additionalFetched({
            additionInfo,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getReferenceList = (id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getReferenceList(id)
    .then((response) => {
      if (response.data.success) {
        const referenceList = response.data?.data?.hrms_references;
        dispatch(
          actions.referenceListFetched({
            referenceList,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getReferenceListForApplicant = (id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getReferenceListForApplicant(id)
    .then((response) => {
      if (response.data.success) {
        const referenceList = response.data?.data?.hrms_references;
        dispatch(
          actions.referenceListFetched({
            referenceList,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getPublicationList = (id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getPublicationList(id)
    .then((response) => {
      if (response.data.success) {
        const publicationList = response.data?.data?.hrms_publication;
        dispatch(
          actions.publicationListFetched({
            publicationList,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getPublicationListForApplicant = (id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getPublicationListForApplicant(id)
    .then((response) => {
      if (response.data.success) {
        const publicationList = response.data?.data?.hrms_publication;
        dispatch(
          actions.publicationListFetched({
            publicationList,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getPortfolioList = (id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getPortfolioList(id)
    .then((response) => {
      if (response.data.success) {
        const portfolioList = response.data?.data?.hrms_portfolio;
        dispatch(
          actions.portfolioListFetched({
            portfolioList,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getPortfolioListForApplicant = (id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getPortfolioListForApplicant(id)
    .then((response) => {
      if (response.data.success) {
        const portfolioList = response.data?.data?.hrms_portfolio;
        dispatch(
          actions.portfolioListFetched({
            portfolioList,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getLanguageList = (id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getLanguageList(id)
    .then((response) => {
      if (response.data.success) {
        const languageList = response.data?.data?.hrms_language_proficiency;
        dispatch(
          actions.languageListFetched({
            languageList,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getLanguageListForApplicant = (id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getLanguageListForApplicant(id)
    .then((response) => {
      if (response.data.success) {
        const languageList = response.data?.data?.hrms_language_proficiency;
        dispatch(
          actions.languageListFetched({
            languageList,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getAllReferenceByApplicants = (id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getAllReferenceList(id)
    .then((response) => {
      if (response.data.success) {
        dispatch(
          actions.referenceFetched({
            referenceList: response.data.data.hrms_references,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getDisciplinaryRecordByApplicants = (id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getDisciplinaryRecord(id)
    .then((response) => {
      if (response.data.success) {
        dispatch(
          actions.disciplinaryRecordFetched({
            disciplinaryRecordList:
              response.data.data.hrms_employee_disciplinary_record,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};
export const getWorkStationByApplicants = (id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getWorkStation(id)
    .then((response) => {
      if (response.data.success) {
        dispatch(
          actions.workStationFetched({
            workStationList: response.data.data.hrms_employee_work_station,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};
export const getFRCByApplicants = (id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getFRC(id)
    .then((response) => {
      if (response.data.success) {
        dispatch(
          actions.frcFetched({
            frcList: response.data.data.hrms_employee_frc,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getApplicantsInfoById = (id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getObjective(id)
    .then((res) => {
      if (res?.data?.success) {
        if (res?.data?.data) {
          dispatch(
            actions.applicantsInfoFetched({
              applicantsInfo: res?.data?.data,
            })
          );
        } else {
          if (res.data.message) {
            swalError(res.data.message);
          }
        }
      } else {
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getApplicantsSocialMedia = (applicant_id, callback) => (
  dispatch
) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getApplicantSocialMedia(applicant_id)
    .then((response) => {
      if (response.data.success) {
        if (callback) callback();
        dispatch(
          actions.applicantSocialMediaFetched({
            social_medias: response.data?.data,
          })
        );
      } else {
        if (callback) callback();
        if (response.data.message) {
          swalError(response.data.message);
        } else {
          swalError("something went wrong");
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const updateProfileScore = (params, callback) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateProfileScore(params)
    .then((response) => {
      if (response.data.success) {
        console.log("Score saved", response);
        if (callback) callback();
      } else {
        if (response.data.message) {
          console.log(response.data.message);
        } else {
          console.log("someting went wrong");
        }
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const createProfileScore = (params, callback) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .createProfileScorePublic(params)
    .then((response) => {
      if (response.data.success) {
        console.log("Score saved", response);
        if (callback) callback();
      } else {
        if (response.data.message) {
          console.log(response.data.message);
        } else {
          console.log("someting went wrong");
        }
        if (callback) callback();
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};
